import { createContext } from "react"
import { UseFontSizeControl } from "./types"

export const FontSizeControlContext = createContext<UseFontSizeControl>(null)
